import React from 'react';
export function ProjectsSection() {
  const hackathons = [{
    id: 1,
    name: 'TailorApply @ CodeWords Hackathon',
    description: 'AI-powered job application automation platform. Intelligently matches users with 50+ relevant positions, dynamically tailors resumes and generates personalized cover letters, and automatically submits applications at scale.',
    image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1772&q=80'
  }, {
    id: 2,
    name: 'ProtoBuddy @ MCP AI Agents Hackathon',
    description: 'AI hardware engineering assistant eliminating component compatibility guesswork. Scrapes datasheets and provides verified compatibility analysis for Arduino/Raspberry Pi. Uses Claude API, Apify for PDF parsing, Redis for RAG-powered caching.',
    image: 'https://images.unsplash.com/photo-1555664424-778a1e5e1b48?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }, {
    id: 3,
    name: 'Drivessist @ SF AI Vibe Coding Hackathon',
    description: 'Real-time proximity warning system with ESP32-C3 microcontroller. Ultrasonic sensors broadcasting distance data via Bluetooth Low Energy. Web Bluetooth API integration for instant audio safety alerts. Sub-100ms response times for collision prevention.',
    image: 'https://images.unsplash.com/photo-1517153295259-74eb0b416cee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }];
  const pastProjects = [{
    id: 1,
    name: 'Phone Case Wallet Prototype',
    date: 'Jan 2024 - Jun 2024',
    description: 'Fingerprint-activated locking mechanism using solenoids. Built with Onshape, Arduino Micro, Soldering.',
    link: 'https://drive.google.com/file/d/15fbm9ClRTtGrJXsIPWVivX_IPkC8_N7y/view',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }, {
    id: 2,
    name: 'Laundry Folding Machine Prototype',
    date: 'Jun 2023 - Aug 2023',
    description: 'Automated folding for multiple clothing types with sorting functionality. Servomotors, Arduino Uno, Onshape, machining with wood and plastic.',
    link: 'https://saiakhilm.github.io/SaiM_LaundryFolder/',
    image: 'https://images.unsplash.com/photo-1545173168-9f1947eebb7f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80'
  }, {
    id: 3,
    name: 'Gesture Controlled Car Project',
    date: 'Jun 2022 - Aug 2022',
    description: 'Remote-controlled car operated by glove-based gesture system. Arduino Uno/Micro, Bluetooth, Accelerometer, DC Motors.',
    link: 'https://saiakhilm.github.io/Sai.M_BSE_Portfolio/',
    image: 'https://images.unsplash.com/photo-1518314916381-77a37c2a49ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1771&q=80'
  }, {
    id: 4,
    name: 'FitnessFormulation Business',
    date: 'Mar 2023 - Present',
    description: 'Online business creating personalized workout plans. Custom website for customer acquisition.',
    link: 'https://akhisai2526.wixsite.com/fitnessformulation',
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80'
  }, {
    id: 5,
    name: 'Published Research Paper',
    date: '2023',
    description: '"An Analysis and Discussion of the Various Signal Acquisition Techniques Used in Speech Decoding Technology". Published in Curieux Academic Journal, Issue 46. Neuroengineering literature review.',
    link: 'https://www.curieuxacademicjournal.com/_files/ugd/99711c_bab2ec6c2f1e4a818f05872fc24e1c14.pdf',
    image: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1773&q=80'
  }, {
    id: 6,
    name: 'Rotary Enterprise Leadership Conference',
    date: 'Mar 2023',
    description: 'Chief Technical Officer in team of 8. 3-day shark-tank-style competition. Designed carbon monoxide detector integrated into mobile phones.',
    image: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1774&q=80'
  }];
  return <section id="projects" className="section-spacing bg-background-dark" data-id="element-115">
      <div className="container-padding max-w-7xl mx-auto" data-id="element-116">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-117">
          Recent Projects
        </h2>
        <p className="text-text-secondary mb-12 max-w-2xl" data-id="element-118">
          Award-winning projects from recent hackathons and competitions
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-119">
          {hackathons.map(project => <div key={project.id} className="card overflow-hidden hover:translate-y-[-5px]" data-id="element-120">
              <div className="aspect-video overflow-hidden" data-id="element-121">
                <img src={project.image} alt={project.name} className="w-full h-full object-cover" data-id="element-122" />
              </div>
              <div className="p-6" data-id="element-123">
                <h3 className="text-xl font-display font-bold mb-3" data-id="element-124">
                  {project.name}
                </h3>
                <p className="text-text-secondary" data-id="element-125">{project.description}</p>
              </div>
            </div>)}
        </div>
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-126">
          Past Projects
        </h2>
        <p className="text-text-secondary mb-12 max-w-2xl" data-id="element-127">
          A selection of previous engineering and business projects
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-128">
          {pastProjects.map(project => <div key={project.id} className="card overflow-hidden hover:translate-y-[-5px]" data-id="element-129">
              <div className="aspect-video overflow-hidden" data-id="element-130">
                <img src={project.image} alt={project.name} className="w-full h-full object-cover" data-id="element-131" />
              </div>
              <div className="p-6" data-id="element-132">
                <div className="text-primary text-sm mb-2" data-id="element-133">{project.date}</div>
                <h3 className="text-xl font-display font-bold mb-3" data-id="element-134">
                  {project.name}
                </h3>
                <p className="text-text-secondary mb-4" data-id="element-135">
                  {project.description}
                </p>
                {project.link && <a href={project.link} target="_blank" rel="noopener noreferrer" className="text-primary font-medium hover:underline" data-id="element-136">
                    View Project →
                  </a>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}